import type { ErrorEvent } from '@sentry/react';

/**
 * `beforeSend` filter for errors no script of ours started: code typed into the
 * console or evaluated by a browser automation tool has no file behind its
 * frames. Only the outermost frame counts, since a `fetch` from such code still
 * passes through Sentry's own fetch wrapper. A builtin like `Array.forEach` is
 * also `<anonymous>`, but without a line number.
 */
export function dropInjectedScriptError(event: ErrorEvent): ErrorEvent | null {
  const outermostFrames = (event.exception?.values ?? []).map(
    (exception) => exception.stacktrace?.frames?.[0],
  );
  if (!outermostFrames.length) {
    return event;
  }
  return outermostFrames.every(
    (frame) => frame?.filename === '<anonymous>' && frame.lineno !== undefined,
  )
    ? null
    : event;
}
